<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['update:modelValue', 'update:focused']);
const { t } = useI18n();
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const statuses = [
    {
        title: t('Lb'),
        value: 'Lb'
    },
    {
        title: t('Kg'),
        value: 'Kg'
    },
    {
        title: t('CF'),
        value: 'CF'
    },
    {
        title: t('M3'),
        value: 'M3'
    },
    {
        title: t('Unit'),
        value: 'Unit'
    },
    {
        title: t('Percentage'),
        value: '%'
    },
    {
        title: t('Unit'),
        value: 'Miles'
    }
];
</script>

<template>
    <v-select
        v-model="selected"
        :items="statuses"
        :label="hideLabel ? '' : $t('Measure')"
        density="compact"
        hide-details
        clearable
        persistent-clear
        @update:modelValue="emit('update:modelValue', selected)"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </v-select>
</template>
